import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { formatCurrency } from '../../utils/currencyUtils';

// Font: Roboto
Font.register({
  family: 'Roboto',
  fonts: [
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf' },
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf', fontWeight: 'bold' },
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf', fontStyle: 'italic' }
  ]
});

const styles = StyleSheet.create({
  // TĂNG FONT CHUNG LÊN 12
  page: { padding: 40, fontFamily: 'Roboto', fontSize: 12, color: '#333' },
  
  // --- HEADER: CHỈNH KÍCH THƯỚC LOGO & CỘT ---
  header: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    marginBottom: 10, 
    borderBottomWidth: 2, 
    borderBottomColor: '#007373', 
    paddingBottom: 15 
  },
  headerLeft: { 
    width: '40%', // Tăng chiều rộng cột chứa logo
    justifyContent: 'center', // Căn logo lên trên cùng
    alignItems: 'flex-start' 
  },
  headerRight: { 
    width: '60%', 
    justifyContent: 'center',
    alignItems: 'flex-end', 
    textAlign: 'right' 
  },
  // Logo to hơn (chiều cao 60-70 tùy ảnh gốc, width auto để giữ tỷ lệ)
  logoImage: { height: 70, objectFit: 'contain' },
  
  brandTitle: { fontSize: 22, fontWeight: 'bold', color: '#007373', marginBottom: 2 },
  tagline: { fontSize: 10, fontStyle: 'italic', marginBottom: 6, color: '#555' },
  companyInfo: { fontSize: 10, lineHeight: 1.3 }, // Tăng font info
  
// --- TITLE ---
  invoiceTitle: { 
    fontSize: 24, 
    fontWeight: 'bold', 
    marginTop: 10, // Giảm từ 15
    marginBottom: 10, // Giảm từ 20
    color: '#2c3e50', 
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 2
  },

  // --- TABLES ---
  table: { width: "100%", borderStyle: "solid", borderRightWidth: 0, borderBottomWidth: 0, marginBottom: 10 }, // Giảm từ 20
  tableRow: { flexDirection: "row" },
  tableColHeader3: { width: "33.33%", borderStyle: "solid", borderWidth: 1, borderColor: '#ccc', backgroundColor: '#f5f5f5', padding: 6 },
  tableCol3: { width: "33.33%", borderStyle: "solid", borderWidth: 1, borderColor: '#ccc', padding: 6 },
  
  tableCellHeader: { fontWeight: 'bold', fontSize: 11 },
  tableCell: { fontSize: 11 }, 

  // --- ITEMS TABLE ---
  itemsTable: { marginTop: 5, marginBottom: 10 }, // Giảm từ 20
  itemHeader: { flexDirection: 'row', borderBottomWidth: 2, borderBottomColor: '#007373', paddingVertical: 8, fontWeight: 'bold', color: '#007373', fontSize: 11 },
  itemRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eee', paddingVertical: 8, fontSize: 11 },
  
  colDesc: { width: '50%' },
  colQty: { width: '15%', textAlign: 'center' },
  colPrice: { width: '15%', textAlign: 'right' },
  colTotal: { width: '20%', textAlign: 'right' },

  // --- TOTALS ---
  totalSection: { marginTop: 0, alignItems: 'flex-end' },
  totalRow: { flexDirection: 'row', marginBottom: 5 },
  totalLabel: { width: 120, textAlign: 'right', marginRight: 10, fontWeight: 'bold', fontSize: 11 },
  totalValue: { width: 110, textAlign: 'right', fontSize: 11 },
  grandTotal: { fontSize: 14, fontWeight: 'bold', color: '#007373', borderTopWidth: 1, borderTopColor: '#ccc', paddingTop: 5 },

  // --- SIGNATURE & FOOTER SECTION ---
  signatureContainer: {
    marginTop: 20, // Kéo gần lại với phần Total
    flexDirection: 'column',
    alignItems: 'center', // Căn giữa
    borderTopWidth: 1, 
    borderTopColor: '#ccc', 
    paddingTop: 15
  },
  signatureName: {
    fontWeight: 'bold',
    fontSize: 14,
    textTransform: 'uppercase',
    color: '#007373',
    marginBottom: 5 // Loại bỏ khoảng trống ký tên khổng lồ
  },
  footerText: { 
    fontSize: 10, 
    color: '#777', 
    fontWeight: 'bold' 
  }
});

const BookingInvoicePdf = ({ data }) => {
  if (!data) return null;

  const logoUrl = typeof window !== 'undefined' ? `${window.location.origin}/fola-travel-logo-with-slogan.png` : '';
  const issueDate = data.invoice_date || new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  const tripDate = data.trip_date || 'TBA';
  
  const items = data.items || [];
  const totalAmount = items.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0);
  const refundAmount = parseFloat(data.refund_amount) || 0;
  const finalTotal = totalAmount - refundAmount;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        
        {/* HEADER */}
        <View style={styles.header}>
          <View style={styles.headerLeft}>
             {/* Logo sẽ tự co giãn theo chiều cao 70 đã set */}
             {logoUrl && <Image style={styles.logoImage} src={logoUrl} />}
          </View>
          <View style={styles.headerRight}>
            <Text style={styles.companyInfo}>Fola Travel and Services Co.Ltd</Text>
            <Text style={styles.companyInfo}>Pavilion P2, Vinhomes Ocean Park, Gia Lam, Hanoi</Text>
            <Text style={styles.companyInfo}>T: +84 986 332 366 | E: folatravel@gmail.com</Text>
            <Text style={styles.companyInfo}>W: www.folatravel.com</Text>
          </View>
        </View>

        {/* INVOICE TITLE */}
        <Text style={styles.invoiceTitle}>TRAVEL INVOICE</Text>

        {/* INFO TABLE 1 */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Invoice Number</Text></View>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Date of Trip</Text></View>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Date of Issue</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{data.invoice_number || data.booking_code}</Text></View>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{tripDate}</Text></View>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{issueDate}</Text></View>
          </View>
        </View>

        {/* INFO TABLE 2 */}
        <View style={styles.table}>
           <View style={styles.tableRow}>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Billed To</Text></View>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Address</Text></View>
            <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Contact Information</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{data.customer_name_display}</Text></View>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{data.customer_address || '---'}</Text></View>
            <View style={styles.tableCol3}><Text style={styles.tableCell}>{data.customer_email || '---'}</Text></View>
          </View>
        </View>

        {/* ITEMS TABLE */}
        <View style={styles.itemsTable}>
          <View style={styles.itemHeader}>
            <Text style={styles.colDesc}>Description</Text>
            <Text style={styles.colQty}>Quantity</Text>
            <Text style={styles.colPrice}>Unit Price</Text>
            <Text style={styles.colTotal}>Total</Text>
          </View>

          {items.map((item, index) => (
            <View key={item._id || index} style={styles.itemRow}>
                <Text style={styles.colDesc}>{item.description}</Text>
                <Text style={styles.colQty}>{item.quantity}</Text>
                <Text style={styles.colPrice}>{formatCurrency(item.unit_price)}</Text>
                <Text style={styles.colTotal}>{formatCurrency(item.total)}</Text>
            </View>
          ))}
        </View>

        {/* TOTALS */}
        <View style={styles.totalSection}>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Subtotal</Text>
            <Text style={styles.totalValue}>{formatCurrency(totalAmount)}</Text>
          </View>
          
          {refundAmount > 0 && (
            <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>Refund</Text>
                <Text style={[styles.totalValue, {color: 'red'}]}>- {formatCurrency(refundAmount)}</Text>
            </View>
          )}

          <View style={[styles.totalRow, {marginTop: 5}]}>
            <Text style={[styles.totalLabel, styles.grandTotal]}>TOTAL AMOUNT</Text>
            <Text style={[styles.totalValue, styles.grandTotal]}>{formatCurrency(finalTotal)}</Text>
          </View>
        </View>

        {/* SIGNATURE & FOOTER SECTION */}
        <View style={styles.signatureContainer}>
            <Text style={styles.signatureName}>FOLA TRAVEL AND SERVICES CO.LTD</Text>
            <Text style={styles.footerText}>Thank you for traveling with us!</Text>
        </View>

      </Page>
    </Document>
  );
};

export default BookingInvoicePdf;